import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepperComponent } from './components/stepper/stepper.component';
import { BreadcrumbMessages } from '../../shared/models/component-messages/breadcrumb-messages';

const breadcrumbMessage = new BreadcrumbMessages();

const routes: Routes = [
  {
    path: '', data: {breadcrumb: breadcrumbMessage.creer}, children: [
      {path: '', component: StepperComponent, data: {breadcrumb: breadcrumbMessage.creer}},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreerRoutingModule {
}
